import React, {PropsWithChildren} from 'react';

import './badge.scss';

interface BadgeProps {
    value?: number;
    color?: 'light' | 'dark';
}

function Badge(props: PropsWithChildren<BadgeProps>): JSX.Element {
    const {color = 'light', children, value} = props;

    let displayedValue = '';
    if (value && value > 0) {
        displayedValue = value > 99 ? '99+' : value.toString();
    }

    return (
        <div className="c-badge">
            {displayedValue && <p className={`c-badge__wrapper c-badge__wrapper--${color}`}>{displayedValue}</p>}
            {children}
        </div>
    );
}

export default Badge;
